import { render, staticRenderFns } from "./Putter.vue?vue&type=template&id=a05e7766&"
import script from "./Putter.vue?vue&type=script&lang=js&"
export * from "./Putter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports